export default __webpack_public_path__ + "static/media/ic_liquidity.e05f6f35.svg";